<template>
  <div class="DatePicker">
    <div class="label">{{ label }}</div>
    <div @click.stop="showPopup" class="text">
      <span v-if="date" class="date">
        {{ date }}
      </span>
      <span v-else class="placeholder">
        {{ placeholder }}
      </span>

      <span class="isMessage" v-if="isMessage">{{ errorMessage }}</span>
    </div>
    <img src="@/assets/images/right-arrow.png" alt="" class="rightArrow">
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '300px' }"
      :close-on-click-overlay="false"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'DatePicker',
  props: {
    label: {
      type: String,
      require: true,
    },
    placeholder: {
      type: String,
    },
    value: {
      require: true,
    },
    errorMessage: {},
    minDate: {},
    maxDate: {},
  },
  data() {
    return {
      show: false,
      currentDate: new Date(),
      date: null,
      isMessage: false,
    };
  },
  watch: {
    value: {
      handler(n) {
        this.date = n;
      },
      immediate: true,
    },
    date: {
      handler(n) {
        this.$emit('input', n);
      }, 
    },
  },
  filters: {
    formatDate(e) {
      return moment(e).format('YYYY-MM-DD');
    },
  },
  created() {},
  computed: {},
  methods: {
    showPopup() {
      this.show = true;
      console.log(this.show, '=show');
    },
    onConfirm(e) {
      this.date = moment(e).format('YYYY-MM-DD'); 
      this.show = false;
      this.onCheck();
    },
    onCancel() {
      this.show = false;
      this.onCheck();
    },
    onCheck() {
      if (this.date) {
        this.isMessage = false;
        return Promise.resolve(true);
      } 
      this.isMessage = true;
      return Promise.resolve(false);
    },
  },
};
</script>
<style lang="scss" scoped>
.DatePicker {
  display: flex;
  background: #fff;
  padding: 12px 16px;
  position: relative;
  .label {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #1c2438;
    display: flex;
    align-items: center;
    width: 80px;
  }
  .text {
    flex: 1;
    text-align: left;
    position: relative;
    .date {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #495060;
      line-height: 24px;
      font-weight: 400;
    }
    .placeholder {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #bcc2cc;
      line-height: 24px;
      font-weight: 400;
    }
     .isMessage {
      position: absolute;
      color: #ee0a24;
      font-size: 12px;
      bottom: -12px;
      left: 0;
    }
  }
  .rightArrow {
    width: 24px;
    height: 24px;
  }
}
</style>
